import React, { createContext, useContext, useState, useEffect } from 'react';
import { login as apiLogin, getCurrentUser } from '../utils/api';

const AuthContext = createContext(null);

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    checkAuth();
  }, []);

  const checkAuth = async () => {
    const token = localStorage.getItem('tsvmap_token');
    if (token) {
      try {
        const response = await getCurrentUser();
        setUser(response.data.user);
      } catch (error) {
        localStorage.removeItem('tsvmap_token');
        localStorage.removeItem('tsvmap_user');
      }
    }
    setLoading(false);
  };

  const login = async (email, password) => {
    const response = await apiLogin(email, password);
    const { token, user: userData } = response.data;
    localStorage.setItem('tsvmap_token', token);
    localStorage.setItem('tsvmap_user', JSON.stringify(userData));
    setUser(userData);
    return userData;
  };

  const logout = () => {
    localStorage.removeItem('tsvmap_token');
    localStorage.removeItem('tsvmap_user');
    setUser(null);
  };

  const value = {
    user,
    login,
    logout,
    loading,
    isAuthenticated: !!user,
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};

export default AuthContext;
